import { formatNumber, formatPercent, formatRial, nodeLabel } from './chainFormat';

export default function MultiBuyerPanel({ data }) {
    const { purchases, perNode } = data;
    const receivers = perNode.filter(({ boxes }) => boxes.length > 0);

    return (
        <div className="chain-multi">
            <div className="chain-multi-summary" aria-label="خلاصه خریدهای انتخاب‌شده">
                <div>
                    <span>تعداد خریداران</span>
                    <strong>{formatNumber(purchases.length)}</strong>
                    <small>{purchases.map(({ label }) => label).join('، ')}</small>
                </div>
                <div>
                    <span>کل پورسانت پرداختی</span>
                    <strong>{formatRial(data.totalCommissionAmount)}</strong>
                </div>
                <div>
                    <span>سهم پلتفرم از سطوح پرداخت‌نشده</span>
                    <strong>{formatRial(data.platformKeptAmount)}</strong>
                </div>
                <div>
                    <span>سود باقی‌مانده (مجموع)</span>
                    <strong className={data.isSafe ? 'is-safe' : 'is-unsafe'}>
                        {formatRial(data.remainingProfitAmount)}
                    </strong>
                    <small>{data.isSafe ? '✅ همه خریدها امن' : '❌ حداقل یک خرید ناامن'}</small>
                </div>
            </div>

            {receivers.length === 0 ? (
                <p className="chain-detail-empty">
                    هیچ‌یک از خریداران انتخاب‌شده معرف بالاسری ندارند؛ پورسانتی پرداخت
                    نمی‌شود.
                </p>
            ) : (
                <div className="chain-multi-matrix-wrap">
                    <table className="chain-multi-matrix" dir="rtl">
                        <thead>
                            <tr>
                                <th scope="col">خریدار</th>
                                {receivers.map(({ nodeIndex }) => (
                                    <th scope="col" key={`head-${nodeIndex}`}>
                                        گره {nodeLabel(nodeIndex)}
                                    </th>
                                ))}
                                <th scope="col">جمع پورسانت این خرید</th>
                            </tr>
                        </thead>
                        <tbody>
                            {purchases.map((purchase) => (
                                <tr key={`purchase-${purchase.buyerIndex}`}>
                                    <th scope="row">
                                        گره {purchase.label}
                                        <small>
                                            سود باقی‌مانده:{' '}
                                            {formatPercent(purchase.remainingProfitPercent)}
                                        </small>
                                        {purchase.payouts.length === 0 && (
                                            <small>پورسانتی پرداخت نمی‌شود</small>
                                        )}
                                    </th>
                                    {receivers.map(({ nodeIndex }) => {
                                        const payout = purchase.payouts.find(
                                            (item) => item.nodeIndex === nodeIndex,
                                        );
                                        return (
                                            <td
                                                key={`cell-${purchase.buyerIndex}-${nodeIndex}`}
                                                className={payout ? '' : 'is-empty'}
                                            >
                                                {payout ? (
                                                    <>
                                                        <strong>{formatRial(payout.amount)}</strong>
                                                        <small>
                                                            {formatPercent(payout.percent)} · سطح{' '}
                                                            {formatNumber(payout.level)}
                                                        </small>
                                                    </>
                                                ) : '—'}
                                            </td>
                                        );
                                    })}
                                    <td className={purchase.totalAmount === 0 ? 'is-empty' : ''}>
                                        {purchase.totalAmount === 0
                                            ? '—'
                                            : formatRial(purchase.totalAmount)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr>
                                <th scope="row">جمع هر گره</th>
                                {receivers.map(({ nodeIndex, total }) => (
                                    <td key={`total-${nodeIndex}`}>
                                        <strong>{formatRial(total)}</strong>
                                    </td>
                                ))}
                                <td>
                                    <strong>{formatRial(data.totalCommissionAmount)}</strong>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            )}

            <p className="chain-detail-rounding-note">
                مبلغ هر سطح جداگانه به ریال کامل گرد می‌شود؛ بنابراین جمع مبالغ ممکن
                است با جمع درصدها یک ریال اختلاف داشته باشد.
            </p>
        </div>
    );
}